var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerpoint = function SvgPowerpoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c43e1c",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.33 6.398a4.4 4.4 0 0 1 2.967.891 3.23 3.23 0 0 1 1.029 2.58 3.66 3.66 0 0 1-.51 1.93 3.44 3.44 0 0 1-1.447 1.313 4.8 4.8 0 0 1-2.174.469h-2.058v3.928H8.026V6.4zm-2.193 5.486h1.816a2.32 2.32 0 0 0 1.606-.492 1.84 1.84 0 0 0 .543-1.437q0-1.837-2.08-1.837h-1.885z"
  })));
};
export default SvgPowerpoint;